import { render, staticRenderFns } from "./ReportsPanel.vue?vue&type=template&id=2c4eb6ac"
import script from "./ReportsPanel.vue?vue&type=script&lang=js"
export * from "./ReportsPanel.vue?vue&type=script&lang=js"
import style0 from "./ReportsPanel.vue?vue&type=style&index=0&id=2c4eb6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports